<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Modal Resizer
Author: SDL
Description: Modal Resizer Common Component
-->
<template>
  <div :class="className"></div>
</template>
<script>
import { inRange } from './utils';

export default {
  name: 'VueJsModalResizer',
  props: {
    minHeight: {
      type: Number,
      default: 0,
    },
    minWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      clicked: false,
      size: {},
    };
  },
  mounted() {
    this.$el.addEventListener('mousedown', this.start, false);
  },
  computed: {
    className() {
      return { 'vue-modal-resizer': true, clicked: this.clicked };
    },
  },
  methods: {
    start(event) {
      this.clicked = true;

      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.stop, false);

      event.stopPropagation();
      event.preventDefault();
    },
    stop() {
      this.clicked = false;

      window.removeEventListener('mousemove', this.mousemove, false);
      window.removeEventListener('mouseup', this.stop, false);

      this.$emit('resize-stop', {
        element: this.$el.parentElement,
        size: this.size,
      });
    },
    mousemove(event) {
      this.resize(event);
    },
    resize(event) {
      const el = this.$el.parentElement;

      if (el) {
        let width = event.clientX - el.offsetLeft;
        let height = event.clientY - el.offsetTop;

        width = inRange(this.minWidth, window.innerWidth, width);
        height = inRange(this.minHeight, window.innerHeight, height);

        this.size = { width, height };
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;

        this.$emit('resize', {
          element: el,
          size: this.size,
        });
      }
    },
  },
};
</script>
<style>
.vue-modal-resizer {
  display: block;
  overflow: hidden;
  position: absolute;
  width: 12px;
  height: 12px;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  background: transparent;
  cursor: se-resize;
}

.vue-modal-resizer::after {
  display: block;
  position: absolute;
  content: '';
  background: transparent;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 10px solid #ddd;
  border-left: 10px solid transparent;
}

.vue-modal-resizer.clicked::after {
  border-bottom: 10px solid #369be9;
}
</style>



// WEBPACK FOOTER //
// src/components/common/control/modal/Resizer.vue